import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Beranda" },
  { to: "/tentang", label: "Tentang" },
  { to: "/layanan", label: "Layanan" },
  { to: "/proyek", label: "Proyek" },
  { to: "/kontak", label: "Kontak" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-[#060B19]/70 backdrop-blur-xl border-b border-white/10"
    >
      <div className="container-site flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group" onClick={() => setOpen(false)}>
          <img
            src="/assets/logo-mark-gold.png"
            alt="Logo PT. Luminara Global Persada"
            className="w-11 h-11 object-contain transition-transform duration-300 group-hover:scale-105"
          />
          <span className="leading-tight">
            <span className="block font-heading font-semibold text-sm tracking-wide text-white">
            PT. Luminara Global Persada
            </span>
            <span className="block text-[10px] tracking-[0.25em] uppercase text-gold/80">
            Construction &bull; Architecture &bull; Trading
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Navigasi utama">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 ${
                  isActive ? "text-gold font-bold" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/kontak" data-testid="nav-cta-button" className="btn-gold !px-5 !py-2.5 !text-xs">
            Hubungi Kami
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Tutup menu" : "Buka menu"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-navy-950/95 backdrop-blur-xl border-t border-white/10"
          aria-label="Navigasi seluler"
        >
          <div className="container-site py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base tracking-wide ${
                    isActive ? "text-gold font-bold" : "text-slate-300"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/kontak"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-button"
              className="btn-gold mt-2"
            >
              Hubungi Kami
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};
